import Vue from 'vue'

const getDefaultState = () => {
    return {
        PaymentsConfiguration: {
            id: 0,
            description: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("service/list-payments-configuration",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listPaymentsConfiguration = result.data.result;

                return listPaymentsConfiguration;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list payments configuration: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`service/get-payments-configuration/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get payments configuration`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get payments configuration: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, paymentsConfigurationRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`service/create-update-payments-configuration`, paymentsConfigurationRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (paymentsConfigurationRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.delete(`service/delete-payments-configuration/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Register deleted with success!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to delete the register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to delete the register: [${error}]`
                };
            }
        }
    },

    async ListPaymentsConfigurationByJob(_, idService) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`service/list-payments-configuration-by-job/${idService}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listPaymentsConfiguration = result.data.result;

                return listPaymentsConfiguration;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list payments configuration: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.PaymentsConfiguration, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.PaymentsConfiguration;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
